/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, { attr } from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type PageType from '@linc-technologies/linced-common/enums/page-type';
import type ReactionType from '@linc-technologies/linced-common/enums/reaction-type';
import PageTypesEnum from 'linced-app/enums/page-type';

// Proto: posts.PageTemplate.
export default class Page extends Model {
  declare [Type]: 'posts/templates/page';

  // Page meta
  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare authorId: string;

  @attr('number', { defaultValue: 0 })
  declare type: EnumValue<typeof PageType> | 0;

  @computed('type')
  get typeName() {
    return PageTypesEnum.getLabel(this.type);
  }

  @attr('boolean', { defaultValue: false })
  declare isPublished: boolean;

  @attr('boolean', { defaultValue: false })
  declare hasAssessments: boolean;

  @attr('boolean', { defaultValue: false })
  declare hasPosts: boolean;

  @attr('boolean', { defaultValue: false })
  declare hasGoals: boolean;

  @attr('boolean', { defaultValue: false })
  declare hasEffort: boolean;

  @attr('boolean', { defaultValue: false })
  declare hasGoalsAsTags: boolean;

  @attr('boolean', { defaultValue: false })
  declare hasOTJAssessment: boolean;

  // Page configuration
  @attr('string', { defaultValue: '' })
  declare icon: string;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare title: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('number', { defaultValue: 0 })
  declare reactionType: EnumValue<typeof ReactionType> | 0;

  // Page visibility
  @attr('boolean', { defaultValue: false })
  declare visibleInMenu: boolean;

  @attr('boolean', { defaultValue: false })
  declare visibleOnContent: boolean;

  @attr('boolean', { defaultValue: false })
  declare visibleOnStudentProfile: boolean;

  @attr('boolean', { defaultValue: false })
  declare visibleToParents: boolean;

  @attr('boolean', { defaultValue: false })
  declare visibleToLearners: boolean;

  // Page authorisation / permissions
  @attr('boolean', { defaultValue: false })
  declare staffCanPublish: boolean;

  @attr('boolean', { defaultValue: false })
  declare staffCanEdit: boolean;

  @attr('boolean', { defaultValue: false })
  declare caregiversCanPost: boolean;

  @attr('boolean', { defaultValue: false })
  declare learnersCanPost: boolean;

  @attr('boolean', { defaultValue: false })
  declare canComment: boolean;

  // Page content filters
  @array('string')
  declare assessmentIds: StatefulArray<string>;

  @array('string')
  declare goalIds: StatefulArray<string>;

  @array('string')
  declare tags: StatefulArray<string>;

  // Page magic
  @attr('boolean', { defaultValue: false })
  declare hasLearnerIcon: boolean;

  @attr('boolean', { defaultValue: false })
  declare hasAutogroup: boolean;

  // Is this a special page
  @attr('boolean', { defaultValue: false })
  declare isAttendance: boolean;

  @attr('boolean', { defaultValue: false })
  declare isSickbay: boolean;

  @attr('boolean', { defaultValue: false })
  declare isSuspensionPosts: boolean;

  @attr('boolean', { defaultValue: false })
  declare isSuspensionLetters: boolean;

  @attr('boolean', { defaultValue: false })
  declare isBehaviour: boolean;
}
